import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

//连续点击多次路由报错解决方法
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  routes: [
    {
      path: '/help',
      name: 'help',
      component: () => import('@/views/Help.vue'),
      meta: {
        title: '帮助手册',
        active: 'help'
      }
    },
	{
	  path: '/information',
	  name: 'information',
	  component: () => import('@/views/Information.vue'),
	  meta: {
	    title: '公司官网',
	    active: 'information'
	  }
	},
	{
	  path: '/sgmCertificate',
	  name: 'sgmCertificateDetail',
	  component: () => import('@/views/SgmCertificateDetail.vue'),
	  meta: {
	    title: '',
	    active: 'home'
	  }
	},
    {
      path: '/map',
      name: 'map',
      component: () => import('@/views/Map.vue'),
      meta: {
        title: '地图',
        active: 'map'
      }
    },
    {
      path: '/message',
      name: 'message',
      component: () => import('@/views/Message.vue'),
      meta: {
        title: '留言信息',
        active: 'message'
      }
    },
	{
	  path: '/postTask',
	  name: 'postTask',
	  component: () => import('@/views/user/postTask.vue'),
	  meta: {
	    title: '发帖',
	  active: 'home'
	  },
	  props: true
	},
	{
		  path: '/postRecord',
		  name: 'postRecord',
		  component: () => import('@/views/user/postRecord.vue'),
		  meta: {
		    title: '帖子列表',
			  active: 'post'
		  },
		  props: true
		},
    {
      path: '/lucky',
      name: 'lucky',
      component: () => import('@/views/Lucky.vue'),
      meta: {
        title: '幸运抽奖',
        active: 'lucky'
      }
    },
	{
	  path: '/luckyRecord',
	  name: 'Raffle Record',
	  component: () => import('@/views/luckyRecord.vue'),
	  meta: {
	    title: '抽奖记录',
	    active: 'lucky'
	  }
	},
    {
      path: '/smart',
      name: 'smart',
      component: () => import('@/views/Smart.vue'),
      meta: {
        title: '云管家',
        active: 'smart'
      }
    },
    {
      path: '/activity',
      name: 'activity',
      component: () => import('@/views/Activity.vue'),
      meta: {
        title: '',
        active: 'activity'
      }
    },
    {
      path: '/article/:articleType/:articleId?',
      name: 'article',
      component: () => import('@/views/Article.vue'),
      meta: {
        title: '内容',
        active: 'article'
      },
      props: true
    },
    {
      path: '/videoGuide',
      name: 'videoGuide',
      component: () => import('@/views/VideoGuide.vue'),
      meta: {
        title: '视频课程',
        active: 'home'
      }
    },
    {
      path: '/service',
      name: 'service',
      component: () => import('@/views/Service.vue'),
      meta: {
        title: '在线客服',
        active: 'service'
      }
    },
    {
      path: '/line',
      name: 'line',
      component: () => import('@/views/Line.vue'),
      meta: {
        title: '切换线路',
        active: 'line'
      }
    },
    {
      path: '/language',
      name: 'language',
      component: () => import('@/views/Language.vue'),
      meta: {
        title: '切换语言',
        active: 'language'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        title: '用户登录',
        active: 'login'
      }
    },
    {
      path: '/register/:recommendId?',
      name: 'register',
      component: () => import('@/views/Register.vue'),
      meta: {
        title: '用户注册',
        active: 'register'
      },
      props: true
    },
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home1.vue'),
      meta: {
        title: '首页',
        active: 'home'
      }
    },
    {
      path: '/home',
      name: 'home1',
      component: () => import('@/views/Home1.vue'),
      meta: {
        title: '首页',
        active: 'home'
      }
    },
    {
      path: '/task/:tabsActive?',
      name: 'task',
      component: () => import('@/views/task/index.vue'),
      meta: {
        title: '任务',
        //active: 'task'
      },
      props: true
    },
    {
      path: '/taskList/:taskType/:taskGrade',
      name: 'taskList',
      component: () => import('@/views/task/list.vue'),
      meta: {
        title: '任务列表',
        //active: 'task'
      },
      props: true
    },
    {
      path: '/taskShow/:taskId',
      name: 'taskShow',
      component: () => import('@/views/task/show.vue'),
      meta: {
        title: '任务详情',
        //active: 'task'
      },
      props: true
    },
    {
      path: '/T',
      name: 'T',
      component: () => import('@/views/M.vue'),
      meta: {
        title: 'T',
        active: 'T'
      }
    },
	{
	  path: '/VIP',
	  name: 'VIP',
	  component: () => import('@/views/Vip.vue'),
	  meta: {
	    title: 'VIP',
	    active: 'VIP'
	  }
	},
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/views/Profile.vue'),
      meta: {
        title: 'PROFILE',
        active: 'profile'
      }
    },
	{
	  path: '/teamDesc',
	  name: 'teamDesc',
	  component: () => import('@/views/teamDesc.vue'),
	  meta: {
	    title: 'teamDesc',
	    active: 'teamDesc'
	  }
	},
    {
      path: '/Job',
      name: 'Job',
      component: () => import('@/views/Job.vue'),
      meta: {
        title: 'JOB',
        active: 'Job'
      }
    },
    {
      path: '/profit',
      name: 'profit',
      component: () => import('@/views/Profit.vue'),
      meta: {
        title: '收益',
        active: 'profit'
      }
    },
    {
      path: '/myTask/:taskState?',
      name: 'myTask',
      component: () => import('@/views/MyTask.vue'),
      meta: {
        title: '我的任务',
        requiresAuth: true,
        active: 'task'
      },
      props: true
    },
    {
      path: '/promote',
      name: 'promote',
      component: () => import('@/views/user/promote.vue'),
      meta: {
        title: '我的推广',
        active: 'Invite'
      }
    },
    {
      path: '/user',
      name: '',
      component: () => import('@/views/UserCenter.vue'),
      meta: {
        requiresAuth: true,
        title: '会员中心',
        active: 'user'
      },
      children: [
        {
          path: '',
          name: 'user',
          component: () => import('@/views/user/index.vue'),
          meta: {
            title: '会员中心',
            active: 'user'
          }
        },
        {
          path: 'info/:type?',
          name: 'info',
          component: () => import('@/views/user/info.vue'),
          meta: {
            title: '个人信息',
            active: 'user'
          },
          props: true
        },
        {
          path: 'set/:setType',
          name: 'set',
          component: () => import('@/views/user/set.vue'),
          meta: {
            title: '用户设置',
            active: 'user'
          },
          props: true
        },
        {
          path: 'dayReport',
          name: 'dayReport',
          component: () => import('@/views/user/dayReport.vue'),
          meta: {
            title: '日结报表',
            active: 'user'
          }
        },
        {
          path: 'fundRecord/:fundState?',
          name: 'fundRecord',
          component: () => import('@/views/user/fundRecord.vue'),
          meta: {
            title: '账变记录',
            active: 'user'
          },
          props: true
        },
        {
          path: 'bankCard',
          name: 'bankCard',
          component: () => import('@/views/user/bankCard.vue'),
          meta: {
            title: '我的银行卡',
            active: 'user'
          }
        },
		
		{
		  path: 'list',
		  name: 'list',
		  component: () => import('@/views/user/list.vue'),
		  meta: {
		    title: '职位列表',
		    active: 'user'
		  }
		},
		{
		  path: 'positions',
		  name: 'positions',
		  component: () => import('@/views/user/positions.vue'),
		  meta: {
		    title: '我的职位',
		    active: 'user'
		  }
		},
		
		{
		  path: 'apply',
		  name: 'apply',
		  component: () => import('@/views/user/apply.vue'),
		  meta: {
		    title: '职位申请',
		    active: 'user'
		  }
		},
    {
      path: 'postionIntro',
      name: 'postionIntro',
      component: () => import('@/views/user/PostionIntro.vue'),
      meta: {
        title: '职位描述',
        active: 'user'
      }
    },
        {
          path: 'wallet/:walletType?',
          name: 'wallet',
          component: () => import('@/views/user/wallet.vue'),
          meta: {
            title: '我的钱包',
            active: 'user'
          },
          props: true
        },
        {
          path: 'recharge/:rechargeId?',
          name: 'recharge',
          component: () => import('@/views/user/recharge1.vue'),
          meta: {
            title: '我要充值',
            active: 'user'
          },
          props: true
        },
       {
          path: 'recharge1',
          name: 'recharge1',
          component: () => import('@/views/user/recharge.vue'),
          meta: {
            title: '我要充值',
            active: 'user'
          },
          props: true
        },
        {
          path: 'digital/:rechargeId?',
          name: 'digital',
          component: () => import('@/views/user/digital.vue'),
          meta: {
            title: '数字货币',
            active: 'user'
          },
          props: true
        },
        {
          path: 'bindAccount',
          name: 'bindAccount',
          component: () => import('@/views/user/bindAccount.vue'),
          meta: {
            title: '绑定账号',
            active: 'user'
          }
        },
        {
          path: 'credit',
          name: 'credit',
          component: () => import('@/views/user/credit.vue'),
          meta: {
            title: '信用中心',
            active: 'user'
          }
        },
        {
          path: 'newLc',
          name: 'newLc',
          component: () => import('@/views/user/newLc.vue'),
          meta: {
            title: '余额理财',
            active: 'user'
          }
        },
        {
          path: 'newlist',
          name: 'newlist',
          component: () => import('@/views/user/newlist.vue'),
          meta: {
            title: '购买记录',
            active: 'user'
          }
        },
        {
          path: 'product/:productId?',
          name: 'product',
          component: () => import('@/views/user/product.vue'),
          meta: {
            title: '余额理财详情',
            active: 'user'
          }
        },
        {
          path: 'withdraw',
          name: 'withdraw',
          component: () => import('@/views/user/withdraw.vue'),
          meta: {
            title: '提现',
            active: 'user'
          }
        },
        {
          path: 'fund',
          name: 'fund',
          component: () => import('@/views/user/fund.vue'),
          meta: {
            title: '我的余额',
            active: 'user'
          }
        },
        {
          path: 'member/:memberId?',
          name: 'member',
          component: () => import('@/views/user/member.vue'),
          meta: {
            title: '会员职位列表',
            active: 'user'
          },
          props: true
        },
        {
          path: 'follow',
          name: 'follow',
          component: () => import('@/views/user/follow.vue'),
          meta: {
            title: '关注我们',
            active: 'user'
          }
        }
      ]
    },
    {
      path: '/user/teamReport',
      name: 'teamReport',
      component: () => import('@/views/user/teamReport.vue'),
      meta: {
        title: '团队报表',
        active: 'teamReport'
      }
    },
	{
	  path: '/directMembers',
	  name: 'directMembers',
	  component: () => import('@/views/DirectMembers.vue'),
	  meta: {
	    title: '直系会员下属',
	    active: 'directMembers'
	  }
	},
  // {
  //   path: 'positions',
  //   name: 'positions',
  //   component: () => import('@/views/positions.vue'),
  //   meta: {
  //     title: '我的职位',
  //     active: 'user'
  //   }
  // },
  // {
  //   path: '/positions/detail',
  //   name: 'positionsDetail',
  //   component: () => import('@/views/positionsDetail.vue'),
  //   meta: {
  //     title: '职位介绍',
  //     active: 'user'
  //   }
  // },
  // {
  //   path: '/positions/apply',
  //   name: 'positionsApply',
  //   component: () => import('@/views/positionsApply.vue'),
  //   meta: {
  //     title: '职位申请',
  //     active: 'user'
  //   }
  // },
    {
      path: '/404',
      name: '404'
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})

export default router
